module.exports = __webpack_public_path__ + "static/media/Facebook.ceb5e0af.svg";